<template>
  <div v-if="isVisible" class="cookie-banner">
    <div class="cookie-banner-content">
      <p class="cookie-text">
        В целях повышения безопасности и удобства использования сайта мы используем файлы «cookie». Оставаясь на нашем сайте, Вы соглашаетесь c
        <a href="/upload/Политика обработки файлов Cookie..docx" target="_blank" class="cookie-link">Политикой обработки файлов cookie</a>
        и даёте своё <a href="/upload/Согласие на обработку ПД (пользователь сайта)..docx" target="_blank" class="cookie-link">согласие на обработку персональных данных</a>.
        Если Вы хотите запретить обработку файлов cookie, отключите их в настройках вашего браузера

      </p>
      <button @click="acceptCookie" class="cookie-button">Понятно</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const isVisible = ref(false);

onMounted(() => {
  if (localStorage.getItem('cookie_consent') !== 'true') {
    isVisible.value = true;
  }
});

const acceptCookie = () => {
  localStorage.setItem('cookie_consent', 'true');
  isVisible.value = false;
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #FFFFFF;
  color: #fff;
  margin: 0 auto;
  padding: 30px 0;
  z-index: 1050;
  box-shadow: 0px 4px 16px 0px #48538B40
}

.cookie-banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  gap: 60px;
}

.cookie-text {
  margin: 0;
  font-size: 14px;
  color: #2B2B2B;
  font-weight: 500;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
}

.cookie-link {
  color: #48538B;
  font-weight: 700;
  text-decoration: none;
  font-style: Bold;
}

.cookie-link:hover {
  text-decoration: none;
}

.cookie-button {
  background-color: #48538B;
  color: #fff;
  border: none;
  padding: 10px 28px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
}

.cookie-button:hover {
  opacity: 0.9;
}

@media (max-width: 1279px) {
  .cookie-banner-content {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .cookie-banner-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .cookie-button {
    width: 100%;
  }
}
</style>
